const API_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';

/**
 * Llama al backend FastAPI para obtener un rendimiento predicho
 * @param {string} departamento - Nombre del departamento (ej: "San Justo")
 * @param {string} cultivo - Nombre del cultivo (ej: "soja")
 * @param {number|string} soil_analyses_id - ID del análisis de suelo
 * @param {string|null} modelo - (Opcional) clave del modelo ML a usar (ej: "gb", "rf", "svr")
 * @returns {Promise<object>} respuesta completa del backend
 */
export async function predictYield(departamento, cultivo, soil_analyses_id, modelo = null) {
  // Validación temprana
  if (!departamento || !cultivo) {
    throw new Error('Departamento y cultivo son obligatorios para predecir.');
  }

  try {
    const payload = {
      departamento,
      cultivo,
      soil_analyses_id,
    };

    // Agregar modelo si el usuario lo especificó
    if (modelo) {
      payload.modelo = modelo;
    }

    const response = await fetch(`${API_URL}/predict`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    // Si hay error HTTP → lanzar mensaje descriptivo
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Error ${response.status}: ${errorText}`);
    }

    return await response.json();
  } catch (err) {
    console.error('❌ Error al llamar /predict:', err);
    throw err;
  }
}

/**
 * Versión futura para listar modelos disponibles desde el backend.
 * Útil para permitir al usuario elegir qué modelo usar.
 */
export async function getAvailableModels() {
  try {
    const response = await fetch(`${API_URL}/`);
    if (!response.ok) {
      throw new Error('No se pudo obtener la lista de modelos del backend.');
    }
    return await response.json();
  } catch (err) {
    console.error('❌ Error obteniendo modelos:', err);
    throw err;
  }
}